import { createFileRoute, redirect } from '@tanstack/react-router';
import { fallback, zodSearchValidator } from '@tanstack/router-zod-adapter';
import z from 'zod';

import { UserStatus } from '../../types/UserStatus';
import { TokenManager } from '../auth/TokenManager';
import { queries } from '../common/api/queryKeys/queries';
import { AdminMembersPage } from '../user/list/AdminMembersPage';
import { Role } from '../user/model/role.model';
import { SessionService } from '../user/session/SessionService';

const usersSearchSchema = z.object({
    searchQuery: fallback(z.string(), '').default(''),
    page: fallback(z.number(), 0).default(0),
    status: z.nativeEnum(UserStatus).optional(),
    supplierGroupIds: fallback(z.array(z.string()), []).default([]),
    customerGroupIds: fallback(z.array(z.string()), []).default([]),
    supplierIds: fallback(z.array(z.string()), []).default([]),
    customerIds: fallback(z.array(z.string()), []).default([]),
});

export const Route = createFileRoute('/_app/members/')({
    validateSearch: zodSearchValidator(usersSearchSchema),
    component: AdminMembersPage,
    beforeLoad: async ({ context }) => {
        const token = await TokenManager.getInstance().getToken();
        const role = await context.queryClient.ensureQueryData<Role>({
            queryKey: queries.role.information.queryKey,
            queryFn: () => SessionService.getInstance().loadRoleInformation(token),
        });

        if (!role.isSuperAdmin()) {
            if (role.isCustomer()) {
                throw redirect({
                    to: '/customer-groups/$groupId/members',
                    params: { groupId: role.group.id },
                });
            }

            if (role.isSupplier()) {
                throw redirect({
                    to: '/supplier-groups/$groupId/members',
                    params: { groupId: role.group.id },
                });
            }

            throw redirect({ to: '/settings' });
        }
    },
});
